module.exports = __webpack_public_path__ + "static/media/paso1.c9293337.PNG";